import { Box, Button, IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';

import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useNavigate } from 'react-router';
import { useOrganizationSelect } from '../../context/OrganizationSelectContext';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';


function Contrats() {

    const [contrats, setContrats] = useState([]);
    const { selectedOrganization } = useOrganizationSelect();
     
      const fetchContrats = async () => {
          try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/contrat`);
            let filteredData = response.data;
            if (selectedOrganization) {
            filteredData = response.data.filter(
              (item) => item.Organization?.name === selectedOrganization
            );
            }
              setContrats(filteredData);
          } catch (error) {
              console.error('Error fetching contrats:', error);
          }
      };
    
      
    
      useEffect(() => {
        fetchContrats();
      }, [selectedOrganization]);
    

          const columns = useMemo(
            () => [
              {
                id: 'contrats', //id used to define `group` column
                columns: [
                  {
                    accessorFn: (row) => `${row.name}`, //accessorFn used to join multiple data into a single cell
                    id: 'name', //id is still required when using accessorFn instead of accessorKey
                    header: 'Nom',
                    size: 250,
                    Cell: ({ renderedCellValue, row }) => (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1rem',
                        }}
                      >{renderedCellValue}
                      </Box>
                    ),
                    filterVariant: 'autocomplete',
                  },
                  {
                    accessorFn: (row) => row.Organization?.name, //accessorFn used to join multiple data into a single cell
                  id: 'organization', //id is still required when using accessorFn instead of accessorKey
                  header: 'Client',
                  size: 250,
                  Cell: ({ renderedCellValue, row }) => (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                      }}
                    >{renderedCellValue}
                    </Box>
                  ),
                  filterVariant: 'autocomplete',
                },
                      {
                      accessorKey: 'reference', //hey a simple column for once
                    header: 'Référence',
                    size: 100,
                  },
                 
                ]}
            ],
            [],
          );
          
        
          const table = useMaterialReactTable({
            columns,
            data: contrats ? contrats : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
            enableColumnOrdering: true,
            enableGrouping: true,
            enableColumnPinning: true,
            enableFacetedValues: true,
            // enableRowSelection: true,
            initialState: {
              density:"compact",
              // showColumnFilters: true,
              // showGlobalFilter: true,
              columnPinning: {
                left: ['mrt-row-expand', 'mrt-row-select'],
                right: ['mrt-row-actions'],
              },
              pagination: {
                pageSize: 50,
      
              }
            },
            paginationDisplayMode: 'pages',
            positionToolbarAlertBanner: 'bottom',
            positionGlobalFilter:"left",
            muiSearchTextFieldProps: {
              variant: 'outlined',
              fullWidth: true,
              
            },
            muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: [50, 100, 150],
            shape: 'rounded',
            variant: 'outlined',
            },
            enableRowActions: true,
            renderRowActionMenuItems: ({ row }) => [
                <MenuItem key="read" onClick={() => navigate(`/dashboard/contrats/${row.original._id}`)}>
                    Voir
                </MenuItem>,
                <MenuItem key="edit" onClick={() => navigate(`/dashboard/contrats/${row.original._id}`)}>
                    Modifier
                </MenuItem>,
            ],
          });
        


const navigate = useNavigate();

return (
    <Box>
        <Typography variant="h4" my={2}>Contrats</Typography>
        {/* <Box display={'flex'} alignItems='center' columnGap={2} sx={{mb:2}}>
            <Box>
                <TextField
                    label="Rechercher..."
                    variant="outlined"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    fullWidth
                    margin="normal"
                    size="small"
                />  
            </Box>
        </Box> */}
        <Box sx={{ flex: 1, minHeight: 0 }}>
            <MaterialReactTable table={table} />
{/*             
            <DataGrid
                density="compact"
                rows={filteredContrats.map(c => ({
                    id: c._id,
                    name: c.name,
                    organization: c.Organization?.name || '',
                    reference: c.reference
                }))}
                columns={[
                    { field: 'name', headerName: 'Nom', flex: 1, minWidth: 80 },
                    { field: 'organization', headerName: 'Organisation', flex: 1, minWidth: 140 },
                    { field: 'reference', headerName: 'Référence', flex: 1, minWidth: 120 },
                    { 
                        field: 'actions', 
                        headerName: 'Actions', 
                        flex: 0.5,
                        minWidth: 80,
                        renderCell: (params) => (
                            <IconButton 
                                color="secondary" 
                                onClick={() => navigate(`/dashboard/contrats/${params.id}`)}
                            >
                                <InfoOutlineIcon />
                            </IconButton>
                        )
                    }
                ]}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                sx={{ height: '70%' }}
            /> */}
        </Box>
    </Box>
)
}

export default Contrats